<template>
  <div v-if="eventHandler">
    <!-- Vue mount component but props is undefined -->
    <h1>{{ eventHandler.name }}</h1>
    <JsonEditor :value="eventHandler" @input="setEventHandler" />
    <button @click="updateEventHandler(eventHandler)">Save</button>
    <button @click="cancelUpdateEventHandler(eventHandlerName)">
      Cancel
    </button>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import JsonEditor from '@/components/JsonEditor.vue'

export default {
  name: 'EventHandlerEdit',
  props: ['eventHandlerName'],
  computed: mapState(['eventHandler']),
  methods: {
    ...mapActions([
      'getEventHandler',
      'updateEventHandler',
      'cancelUpdateEventHandler'
    ]),
    ...mapMutations(['setEventHandler'])
  },
  created() {
    this.getEventHandler(this.eventHandlerName)
  },
  watch: {
    eventHandlerName: function() {
      this.getEventHandler(this.eventHandlerName)
    }
  },
  components: {
    JsonEditor
  }
}
</script>
